export const OCCUPANCY_MODE_LABELS = {
  physical: '实际入驻',
  registration: '注册地址'
} as const

export const LEASE_ACTION_LABELS = {
  setup: '设立',
  change: '变更',
  registration: '登记'
} as const

export const OCCUPANCY_MODE_COLORS = { physical: 'blue', registration: 'cyan' } as const satisfies Record<
  keyof typeof OCCUPANCY_MODE_LABELS,
  string
>

export const LEASE_ACTION_COLORS = {
  setup: 'green',
  change: 'orange',
  registration: 'purple'
} as const satisfies Record<keyof typeof LEASE_ACTION_LABELS, string>
